import logger from '@/logger';
import Api from './api';

export default {
  getOrgs: async ({ state, commit, dispatch }) => {
    try {
      const res = await Api.getOrgs();
      commit('setOrgs', res.data);
      if (!state.orgId) {
        dispatch('setOrg', res.data[0]._id); // eslint-disable-line
      }
    } catch (err) {
      if (err.response && err.response.status === 403) {
        dispatch('users/logout', {}, { root: true });
      }
      logger.error(err);
    }
  },
  // Currently not used anywhere - set it up just in case
  postOrg: async ({ dispatch }) => {
    try {
      await Api.postOrg();
    } catch (err) {
      if (err.response.status === 403) {
        dispatch('users/logout', {}, { root: true });
      }
      logger.error(err);
    }
  },
  addOrg: async ({ commit }, payload) => {
    commit('ADD_ORG', payload);
  },
  setOrg: ({ commit, dispatch }, payload) => {
    commit('setOrgId', payload);
    dispatch('getInviteCode');
    dispatch('projects/getProjectList', null, { root: true });
  },
  getInviteCode: async ({ getters, state, commit }) => {
    if (getters.inviteLink) {
      // already populated.
      return;
    }
    const { orgId } = state;
    try {
      const res = await Api.getInviteCode(orgId);
      commit('setInviteCode', { orgId, code: res.data.code });
    } catch (err) {
      logger.error('problem getting invite code', err);
    }
  },
  clear({ commit }) {
    commit('CLEAR');
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/orgs/actions.js